import { graphql } from "msw";
import { MOCK_FOOTER_DATA } from "../../components/Footer/mock-data";
export var footerHandlers = [graphql.query("FooterData", function (_request, response, ctx) {
  return response(ctx.data({
    footer: MOCK_FOOTER_DATA
  }));
})];